<template>
  <ws-wrapper
    :class="{
      'ws-icon ws-icon__wrapper flex items-center': wrap,
      circle: circle,
      [bgColorClass]: bgColor,
    }"
    :wrap="wrap"
    :style="sizes"
  >
    <component
      :is="unloaded ? 'span' : 'inline-svg'"
      v-bind="$attrs"
      :class="classes"
      :src="iconUrl"
      :title="name"
      :style="sizes"
      :circle="circle"
      :data-test="'ws-icon-' + name"
      v-on="$listeners"
    >
      □
    </component>
    <slot></slot>
  </ws-wrapper>
</template>

<script lang="ts">
import {Watch, Component, Prop, Vue} from 'vue-property-decorator';
import InlineSvg from 'vue-inline-svg';
import './helpers/WsWrapper.js';
import {loadIcon} from '@loopia-group/assets';
import {config} from '@loopia-group/services';

@Component({
  name: 'WsIcon',
  components: {
    InlineSvg,
  },
})
export class WsIcon extends Vue {
  @Prop(String) readonly name!: string;
  @Prop(Boolean) readonly wrap!: boolean;
  @Prop(String) readonly color!: string;
  @Prop(String) readonly bgColor!: string;
  @Prop(Boolean) readonly circle!: boolean;

  @Prop() readonly size!: number;
  @Prop({default: 16}) height!: string;
  @Prop({default: 16}) width!: string;

  loading = true;
  iconUrl = '';
  config = config;

  get classes() {
    const classes = ['ws-icon'];

    if (this.color) {
      classes.push('text-' + this.color);
    }

    if (this.unloaded) {
      classes.push('unloaded');
    }

    return classes;
  }

  get bgColorClass() {
    return 'text-' + this.bgColor;
  }

  get sizes() {
    let height;
    let width;

    if (this.size) {
      height = this.size.toString();
      width = this.size.toString();
    } else {
      height = this.height;
      width = this.width;
    }

    return `
      height: ${height}px;
      min-height: ${height}px;
      width: ${width}px;
      min-width: ${width}px;
    `;
  }

  get unloaded() {
    return this.loading || !this.iconUrl;
  }

  @Watch('name', {immediate: true})
  @Watch('config.theme', {immediate: true})
  async getIcon() {
    this.iconUrl = await loadIcon(this.name);
    this.loading = false;
  }
}

export default WsIcon;
</script>

<style lang="scss">
.ws-icon {
  *:not([fill]) {
    fill: currentColor;
  }

  &.circle {
    border-radius: 50%;
  }
}

.circle {
  background-color: currentColor;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    zoom: 0.75;
  }
}
</style>
